import { Schema } from 'prosemirror-model';
import { getImageNode } from '../Image/nodes/image';
import { code } from './marks/code';
import { emphasis } from './marks/emphasis';
import { strong } from './marks/strong';
import { getBlockquoteNode } from './nodes/blockquote';
import { getCodeBlockNode } from './nodes/codeBlock';
import { getDocNode } from './nodes/doc';
import { getHardBreakNode } from './nodes/hardBreak';
import { getHeadingNode } from './nodes/heading';
import { getHorizontalRuleNode } from './nodes/horizontalRule';
import { getParagraphNode } from './nodes/paragraph';
import { getTapLoaderNode } from './nodes/tapLoader';
import { getTextNode } from './nodes/text';
let nodes = {},
  marks = {};
export const getBasicSchema = options => {
  nodes = {
    doc: getDocNode(),
    paragraph: getParagraphNode(options),
    blockquote: getBlockquoteNode(options),
    horizontal_rule: getHorizontalRuleNode(),
    heading: getHeadingNode(options),
    code_block: getCodeBlockNode(options),
    text: getTextNode(),
    image: getImageNode(options),
    hard_break: getHardBreakNode(),
    tap_loader: getTapLoaderNode(options)
  };
  marks = {
    em: emphasis(),
    strong: strong(),
    code: code()
  };
  return new Schema({
    nodes,
    marks
  });
};